import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import { Menu } from 'semantic-ui-react';

import { SatCoreRegister } from '../SatCoreRegistry';
import { ASSIGNMENT_MENU_STATUS } from '../managers/AssignmentManager';

const StudentAssignmentMenuStatusTabs = observer((props = {}) => {
  const {
    activeMenuStatus,
    idPrefix = 'student-assignment',
    loading,
    loadingClassName,
    onClick,
    tabPanelId = 'student-assignment-tabpanel',
    t
  } = props;

  const { assignmentManager } = useContext(MobXProviderContext);

  const menuStatusOrder = assignmentManager.studentAssignmentMenuStatusOrderArray || [
    ASSIGNMENT_MENU_STATUS.CURRENT,
    ASSIGNMENT_MENU_STATUS.TODAY,
    ASSIGNMENT_MENU_STATUS.CLOSED,
    ASSIGNMENT_MENU_STATUS.GRADED
  ];

  return (
    <div className='StudentAssignmentMenuStatusTabs sa-menu-control'>
      <Menu className='student-menu' role='tablist'>
        {menuStatusOrder.map((status) => (
          <Menu.Item key={status}
            active={activeMenuStatus === status}
            aria-controls={tabPanelId}
            aria-selected={activeMenuStatus === status}
            as='button'
            className={classNames(status, {
              [loadingClassName]: loading
            })}
            id={`${idPrefix}-tab-${status}`}
            name={status}
            onClick={onClick}
            tabIndex='0'
            role='tab'>
            <div>{t(ASSIGNMENT_MENU_STATUS.getTitle(status))}</div>
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
});
export default StudentAssignmentMenuStatusTabs;

SatCoreRegister('StudentAssignmentMenuStatusTabs', StudentAssignmentMenuStatusTabs);
